var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('a-loading'):_vm._e()],1),_c('div',{attrs:{"id":"nav"}},[_c('a-navigation')],1),(!_vm.loading)?_c('main',[_c('router-view')],1):_vm._e(),_c('a-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }